<template>
  <div class="changeBox">
    <div class="change">
      <van-form show-error ref="vantForm">
        <van-field
          v-model="oldPassword"
          name="oldPassword"
          center
          placeholder="请输入旧密码"
          :rules="[
            { required: true },
            {
              validator: oldPasswordYz,
              message: '请使用字母或数字，长度不低于6位',
            },
          ]"
        >
          <template #button>
            <img
              src="@/assets/img/x.png"
              alt=""
              @click.stop="cleanOldpassword"
            />
          </template>
        </van-field>
        <van-field
          v-model="newPassword"
          name="newPassword"
          :type="type1 ? 'password' : 'text'"
          center
          placeholder="请输入新密码"
          :rules="[
            {
              validator: newPasswordYz,
              message: '请使用字母或数字，长度不低于6位',
            },
          ]"
        >
          <template #button>
            <div @click="changeType1">
              <img
                src="@/assets/img/形状_1 (1).png"
                alt=""
                style="width: 19px; height: 8px"
                v-if="type1"
              />
              <img
                src="@/assets/img/形状_2.png"
                alt=""
                style="width: 23px; height: 14px"
                v-else
              />
            </div>
          </template>
        </van-field>
        <van-field
          v-model="newPasswords"
          name="newPasswords"
          :type="type2 ? 'password' : 'text'"
          center
          placeholder="请重复新密码"
          :rules="[{ validator: PasswordsYz, message: '两次密码不一致' }]"
          style="margin-bottom: 40px"
        >
          <template #button>
            <div @click="changeType2">
              <img
                src="@/assets/img/形状_1 (1).png"
                alt=""
                style="width: 19px; height: 8px"
                v-if="type2"
              />
              <img
                src="@/assets/img/形状_2.png"
                alt=""
                style="width: 23px; height: 14px"
                v-else
              />
            </div>
          </template>
        </van-field>
      </van-form>
      <div class="change-button" @click="change">确定</div>
    </div>
    <!-- 底部 -->
    <div class="Foot">
      <div class="w">
        <div class="Foot-top">
          <img class="img" src="@/assets/img/logo2.png" alt="" />
          <div class="text1">联系方式</div>
          <div class="text2">0752-5333315</div>
          <div class="text3">惠州市西顿工业发展有限公司 粤ICP备07509439号</div>
        </div>
        <div class="Foot-bottom">粤公网安备44130202000046号</div>
      </div>
    </div>
  </div>
</template>

<script>
import { $change_password } from "@/api";
export default {
  data() {
    return {
      type1: true, // 控制 密码框/输入框
      type2: true, // 控制 确认密码框/输入框
      oldPassword: "", // 旧密码
      newPassword: "", // 新密码
      newPasswords: "", // 确认密码
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          if (document.documentElement.clientWidth > 767) {
            this.$router.push({ name: "change", query: { index: 2 } });
          }
        });
      })();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    // 旧密码验证
    oldPasswordYz(val) {
      return /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9.!@#$%^&*()_+?<>:;]{6,20}$/.test(
        val
      );
    },

    // 验证新密码
    newPasswordYz(val) {
      return /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9.!@#$%^&*()_+?<>:;]{6,20}$/.test(
        val
      );
    },
    // 验证重复密码
    PasswordsYz(val) {
      if (val == "") {
        false;
      }
      return val == this.newPassword;
    },
    // 清除旧密码
    cleanOldpassword() {
      this.oldPassword = "";
    },
    // 切换新密码的后缀图标
    changeType1() {
      this.type1 = !this.type1;
    },
    // 切换确认密码的后缀图标
    changeType2() {
      this.type2 = !this.type2;
    },
    // 点击确认
    async change() {
      this.$refs.vantForm
        .validate()
        .then(async () => {
          try {
            let params = {
              old_psw: this.oldPassword,
              new_psw: this.newPassword,
              confirm_psw: this.newPasswords,
            };
            let res = await $change_password(params);
            this.$toast.success("修改成功,请重新登陆");
            setTimeout(() => {
              this.$router.push({ name: "Login" });
            }, 1500);
          } catch (error) {}
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.changeBox {
  width: 100vw;
  height: 100vh;
  background: #fff;
}

.change {
  width: 70%;
  // min-height: 100vh;
  margin: 0 auto;
  padding-top: 60px;

  /deep/.van-cell {
    background-color: #f7f8fa;
    margin-bottom: 11px;
  }

  /deep/.van-field__button {
    img {
      cursor: pointer;
      width: 14px;
      height: 14px;
    }
  }

  .change-button {
    cursor: pointer;
    width: 100%;
    height: 50px;
    background: #e60012;
    border-radius: 5px;
    margin: 0 auto;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.Foot {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin: 0 auto;

  .w {
    // width: 1280px;
    margin: 0 auto;
  }

  .Foot-top {
    background: #ffffff;
    padding-top: 24px;
    padding-bottom: 15px;
    padding-left: 46px;
    padding-right: 46px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .img {
      width: 116px;
      height: 15px;
      margin-bottom: 24px;
      object-fit: cover;
    }

    .text1 {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: 16px;
    }

    .text2 {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #e60000;
      margin-bottom: 12px;
    }

    .text3 {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-bottom: 20px;
      text-align: center;
    }
  }

  .Foot-bottom {
    width: 100%;
    height: 48px;
    background: #f9f9f9;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
